/* ═══════════════════════════════════════════════════════════════════════════
   <dyc-kit-builder> — guided car kit builder (Phase 2, DEV THEME)

   v2: SunGod-style hero render pane (selected colour's SPEED SHAPE, large, always
   visible — matte by default, gloss once UHG is chosen), colour-type filter chips,
   per-colour highlights, product imagery on sprayer cards, matte-vs-gloss speed
   shape cards on the finish step, and free back-and-forth via step chips.

   Data: colour catalogue (metafields incl. speed shapes) is Liquid-rendered into
   [data-kb-catalog] by sections/kit-builder.liquid; variants/prices fetched from
   products.json and merged by handle. State lives in the URL hash (#kb=…).

   ⚠️ NOT LIVE-READY: ShipStation order-properties parity with ckb26 is TODO.
   ═══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (customElements.get('dyc-kit-builder')) return;

  var VEHICLES = [
    { key: 'compact', opt: 'Small',       label: 'Small',  eg: 'ATV, Side by Side, Slingshot. Not suitable for Cars.' },
    { key: 'sedan',   opt: 'Medium',      label: 'Medium', eg: 'Model 3, Mustang, 3 Series, Civic or similar' },
    { key: 'suv',     opt: 'Large',       label: 'Large',  eg: '5 Series, A7, S Class, CX-5, or similar' },
    { key: 'xl',      opt: 'Extra Large', label: 'XL',     eg: 'F-150, Q7, 4 Runner, X7 or similar' }
  ];
  var SPRAYERS = [
    { key: 'own',      match: /no,|already/i, label: 'I already have one',       sub: 'Approved HVLP or DipSprayer works', img: 'noSprayer' },
    { key: 'gforce',   match: /g-?force/i,    label: 'G-Force sprayer',          sub: 'Our proven starter system',    img: 'gforce' },
    { key: 'ultimate', match: /ultimate/i,    label: 'Ultimate sprayer',         sub: 'Double the power, finest finish', img: 'ultimate' }
  ];
  var FINISHES = [
    { key: 'satin', match: /satin|standard|matte/i, label: 'Standard Satin',   sub: 'The classic dip look' },
    { key: 'uhg',   match: /ultra|gloss|uhg/i,      label: 'Ultra High Gloss', sub: 'Wet-look, extra cans included' }
  ];
  var FILTERS = [
    { key: 'all',      label: 'All',        test: function () { return true; } },
    { key: 'solid',    label: 'Solid',      test: function (c) { return /solid/i.test(c.style); } },
    { key: 'metallic', label: 'Metallic',   test: function (c) { return /metallic/i.test(c.style); } },
    { key: 'shift',    label: 'ColorShift', test: function (c) { return /colorshift/i.test(c.style); } },
    { key: 'hyper',    label: 'HyperShift', test: function (c) { return /hyper|holographic/i.test(c.style); } }
  ];
  var FAMILY_HEX = {
    'black': '#141414', 'blue': '#2456c4', 'green': '#1e8a3c', 'silver/grey': '#b0b6bf',
    'purple': '#7b3fbf', 'red': '#c81e1e', 'tan/brown': '#b08a5a', 'white': '#f4f4f4',
    'orange': '#ef7c1a', 'gold': '#c9a227', 'yellow': '#f2d417', 'teal': '#1aa5a0',
    'pink': '#e86ab4', 'brown': '#6b4226', 'copper/bronze': '#b06c3f'
  };
  var STEPS = ['Vehicle', 'Color', 'Sprayer', 'Finish', 'Review'];
  var TIPS = {
    1: "First things first — what are we painting? This decides how much paint lands on your doorstep, and a little extra always beats running dry on the last panel.",
    2: "The fun part. Filter by color type and tap around — the big picture up top is the exact shape we spray every color on. Go with the one you can't stop looking at.",
    3: "No sprayer? The G-Force is what I hand first-timers. Already got an HVLP or DipSprayer? Keep your money — it'll do the job.",
    4: "This is YOUR color in both finishes. Satin is the classic dip look and the easiest to spray. Gloss is stunning but wants a steadier hand.",
    5: "That's your kit — sized to your ride, everything in one box. Look it over, then send it."
  };

  var AI_ICON = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M2.5 16.5v-1.2c0-.6.4-1.1 1-1.2l2.2-.5 1.7-3.4a2.2 2.2 0 0 1 2-1.2h4.4c.68 0 1.32.3 1.74.83l2.06 2.57 3.4.7c.57.12.9.57.9 1.15v1.25a1 1 0 0 1-1 1h-1.2"/>' +
    '<circle cx="7.3" cy="16.8" r="1.9"/><circle cx="16.9" cy="16.8" r="1.9"/><path d="M9.2 16.8h5.8"/>' +
    '<path d="M18.4.9l.62 1.48 1.48.62-1.48.62-.62 1.48-.62-1.48-1.48-.62 1.48-.62z" fill="currentColor" stroke="none"/>' +
    '<path d="M21.9 4.6l.37.9.9.37-.9.37-.37.9-.37-.9-.9-.37.9-.37z" fill="currentColor" stroke="none"/></svg>';
  var GAL_ICON = '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z"/><circle cx="12" cy="13" r="3"/></svg>';
  var BOX_ICON = '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.29 7 12 12 20.71 7"/><line x1="12" x2="12" y1="22" y2="12"/></svg>';
  function money(n) { return '$' + n.toFixed(2).replace(/\.00$/, ''); }
  function esc(s) { return String(s == null ? '' : s).replace(/"/g, '&quot;'); }

  function KB() { return Reflect.construct(HTMLElement, [], KB); }
  KB.prototype = Object.create(HTMLElement.prototype);
  KB.prototype.constructor = KB;

  KB.prototype.connectedCallback = function () {
    var self = this;
    this.mode = this.getAttribute('mode') || 'expert';
    this.surface = location.pathname.indexOf('/products/') === 0 ? 'pdp'
      : location.pathname.indexOf('/pages/car-kits') === 0 ? 'landing'
      : location.pathname === '/' ? 'home' : 'other';
    this.entry = 'none';
    this.preset = this.getAttribute('preset') || 'full';
    this.collection = this.getAttribute('collection') || 'dipyourcar-peelable-car-kits';
    this.imgs = { noSprayer: this.getAttribute('img-no-sprayer'), gforce: this.getAttribute('img-gforce'), ultimate: this.getAttribute('img-ultimate'),
      compact: this.getAttribute('img-veh-compact'), sedan: this.getAttribute('img-veh-sedan'),
      suv: this.getAttribute('img-veh-suv'), xl: this.getAttribute('img-veh-xl') };
    this.state = { step: 1, vehicle: null, colour: null, sprayer: null, finish: 'satin', filter: 'all', cfilter: 'all', view: 'shape', ess: {} };
    this.rendersBase = this.getAttribute('renders-base') || '';
    this.demoVideo = this.getAttribute('demo-video') || '';
    this.renderMap = {};
    var mapUrl = this.getAttribute('render-map');
    if (mapUrl) { var kb = this; fetch(mapUrl).then(function (r) { return r.json(); }).then(function (j) { kb.renderMap = j || {}; if (kb.dialog && kb.dialog.open) kb.render(); }).catch(function () {}); }
    this.catalog = [];
    this.variantsByHandle = {};
    this.gallery = {};
    this.pids = {};
    this.ratings = {};
    this.compare = [];
    this.compareMode = false;
    this.dialog = null;

    var cat = document.querySelector('[data-kb-catalog]');
    if (cat) { try { this.catalog = JSON.parse(cat.textContent); } catch (e) { this.catalog = []; } }
    var cp = document.querySelector('[data-kb-copy]');
    this.copy = { sprayer: {}, finish: {} };
    if (cp) { try { this.copy = Object.assign(this.copy, JSON.parse(cp.textContent)); } catch (e) {} }
    var ess = document.querySelector('[data-kb-ess]');
    this.essCatalog = [];
    if (ess) { try { this.essCatalog = (JSON.parse(ess.textContent) || []).filter(Boolean).filter(function (x) { return x.av; }); } catch (e) {} }
    var box = document.querySelector('[data-kb-box]');
    this.box = []; this.boxMeta = { title: 'Every kit arrives complete', sub: 'Whichever color you choose, this is in the box — sized to your vehicle.' };
    if (box) { try {
      var bj = JSON.parse(box.textContent);
      this.box = (bj.items || bj).filter(function (x) { return x.img; });
      if (bj.title) this.boxMeta.title = bj.title;
      if (bj.sub) this.boxMeta.sub = bj.sub;
    } catch (e) {} }

    window.addEventListener('resize', function () { self.fitSummaryMedia(); });
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-kit-builder-open]');
      if (!t) return;
      e.preventDefault();
      self.mode = t.getAttribute('data-builder-mode') || self.mode;
      self.preset = t.getAttribute('data-builder-preset') || self.preset;
      self.entry = t.getAttribute('data-builder-product') ? 'product-cta' : 'button';
      self.open(t.getAttribute('data-builder-product') || null);
    });

    if (location.hash.indexOf('#kb=') === 0) {
      try { this.state = Object.assign(this.state, JSON.parse(atob(location.hash.slice(4)))); this.entry = 'resume'; this.open(null, true); }
      catch (err) {}
    } else {
      // external/campaign entry: ?builder opens it, ?builder=<kit-handle> preselects
      var qs = new URLSearchParams(location.search);
      if (location.hash === '#builder' || qs.has('builder')) {
        var pre = qs.get('builder');
        this.entry = 'campaign-url';
        this.open(pre && this.colourOf(pre) ? pre : null);
      }
    }
  };

  KB.prototype.sprayerOpts = function () {
    return this.preset === 'beginner'
      ? SPRAYERS.filter(function (x) { return x.key !== 'ultimate'; })
      : SPRAYERS;
  };
  KB.prototype.colourOf = function (handle) {
    return this.catalog.find(function (c) { return c.handle === handle; }) || null;
  };
  // hero image: chosen colour's speed shape — matte until UHG is picked, then gloss
  KB.prototype.heroSrc = function (c) {
    if (!c) return null;
    var wantGloss = this.state.finish === 'uhg';
    return (wantGloss && c.gloss) || c.matte || c.img || null;
  };
  // AI car render for a colour at a given vehicle size
  KB.prototype.renderSrcFor = function (handle, vehKey) {
    if (!handle || !this.rendersBase) return null;
    var slug = this.renderMap[handle];
    if (!slug) return null;
    var size = { compact: '-atv', sedan: '', suv: '-large', xl: '-xl' }[vehKey] || '';
    var fin = this.state.finish === 'uhg' ? 'gloss' : 'matte';
    return this.rendersBase + slug + size + '-' + fin + '.webp';
  };
  KB.prototype.renderSrc = function (c) {
    return c ? this.renderSrcFor(c.handle, this.state.vehicle) : null;
  };

  KB.prototype.open = function (productHandle, restored) {
    var self = this;
    this._flashed = false;
    // cart "Edit kit" entry: ?edit=<line key> seeds the replace list so the
    // next cart sync swaps the old line for the corrected build; eqty keeps
    // the customer's quantity through the edit
    try {
      var eq = new URLSearchParams(location.search);
      var ek = eq.get('edit');
      if (ek && !this._editConsumed) {
        this._editConsumed = true;
        this._xKeys = [ek];
        this._xSynced = false; this._xSig = null;
        this._editQty = parseInt(eq.get('eqty'), 10) || 1;
        this.entry = 'edit';
      }
    } catch (e) {}
    // colour already chosen (PDP CTA, campaign URL, resume) -> the color step
    // leaves the default flow. Section toggle skip-color="off" disables.
    this.skipColor = this.getAttribute('skip-color') !== 'off' &&
      !!((productHandle && this.colourOf(productHandle)) || (restored && this.state.colour));
    if (!this.dialog) this.build();
    this.dialog.showModal();
    document.documentElement.style.overflow = 'hidden';
    this.track('builder_open', { label: this.surface + ':' + this.entry, skin: this.mode, surface: this.surface, entry: this.entry });
    if (productHandle && this.colourOf(productHandle)) this.state.colour = productHandle;
    this.render();
    var rv = this.dialog.querySelector('.kb__rail-video video');
    if (rv && rv.offsetParent && window.innerWidth >= 900) {
      rv.muted = false;
      rv.play().catch(function () { rv.muted = true; rv.play().catch(function () {}); });
    }
    this.loadVariants().then(function () {
      self.render();
      if (self.state.colour && self.kitOut(self.state.colour)) self.openOOS(self.state.colour);
    });
    if (!restored) this.syncHash();
  };
  KB.prototype.close = function () {
    if (this.dialog && this.dialog.open) this.dialog.close();
    document.documentElement.style.overflow = '';
    history.replaceState(null, '', location.pathname + location.search);
  };

  // color search: neat drawer with a type-to-search input; tapping a result
  // preselects the color and returns to the flow
  KB.prototype.openSearch = function () {
    var self = this, d = this.dialog;
    if (!d || d.querySelector('.kb__srch')) return;
    var g = document.createElement('div');
    g.className = 'kb__srch';
    g.innerHTML = '<div class="kb__srch-scrim"></div>' +
      '<div class="kb__srch-sheet">' +
        '<button type="button" class="kb__gal-x kb__srch-x" aria-label="Close">✕</button>' +
        '<b class="kb__srch-title">Find your color</b>' +
        '<div class="kb__srch-field">' +
          '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.8-3.8"/></svg>' +
          '<input type="search" placeholder="Try Midnight Purple, Gold, ColorShift…" autocomplete="off">' +
        '</div>' +
        '<div class="kb__srch-results"></div>' +
      '</div>';
    var input = g.querySelector('input');
    var results = g.querySelector('.kb__srch-results');
    var closeS = function () { g.classList.remove('is-open'); setTimeout(function () { g.remove(); }, 320); };
    g.addEventListener('click', function (ev) {
      if (ev.target.closest('.kb__srch-x') || ev.target.classList.contains('kb__srch-scrim')) { closeS(); return; }
      var row = ev.target.closest('[data-srch-pick]');
      if (row) {
        self.state.colour = row.getAttribute('data-srch-pick');
        self.track('builder_search_pick', { label: self.state.colour });
        self.syncHash();
        closeS();
        self.render();
        if (self.kitOut(self.state.colour)) self.openOOS(self.state.colour);
      }
    });
    input.addEventListener('input', function () {
      var q = input.value.trim().toLowerCase();
      if (q.length < 2) { results.innerHTML = ''; return; }
      var hits = self.catalog.filter(function (c) {
        return c.title.toLowerCase().indexOf(q) !== -1 ||
          (c.cf || '').toLowerCase().indexOf(q) !== -1 ||
          (c.style || '').toLowerCase().indexOf(q) !== -1;
      }).slice(0, 30);
      results.innerHTML = hits.length ? hits.map(function (c) {
        var thumb = c.thumb || c.matte || c.img || '';
        return '<button type="button" class="kb__srch-row" data-srch-pick="' + c.handle + '">' +
          (thumb ? '<img src="' + thumb + '" loading="lazy" alt="">' : '<span></span>') +
          '<span class="kb__srch-row-txt"><b>' + c.title + '</b>' + (c.cf ? '<i>' + c.cf + '</i>' : '') + '</span>' +
          '<em>›</em></button>';
      }).join('') : '<p class="kb__srch-none">No colors match "' + input.value.replace(/[<>&]/g, '') + '". Try a family like Blue or Pearl.</p>';
    });
    d.querySelector('.kb__chrome').appendChild(g);
    requestAnimationFrame(function () { requestAnimationFrame(function () { g.classList.add('is-open'); }); });
    setTimeout(function () { try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); } }, 420);
    this.track('builder_search_open', {});
  };

  // tap the speedshape for a larger look
  KB.prototype.openZoom = function () {
    var d = this.dialog;
    var img = d.querySelector('.kb__hero-img img');
    if (!img || img.hidden || !img.src || d.querySelector('.kb__zoom')) return;
    var g = document.createElement('div');
    g.className = 'kb__zoom';
    g.innerHTML = '<img src="' + img.src + '" alt="">' +
      '<button type="button" class="kb__gal-x kb__zoom-x" aria-label="Close">✕</button>';
    g.addEventListener('click', function () {
      g.classList.remove('is-open');
      setTimeout(function () { g.remove(); }, 260);
    });
    d.querySelector('.kb__chrome').appendChild(g);
    requestAnimationFrame(function () { requestAnimationFrame(function () { g.classList.add('is-open'); }); });
    this.track('builder_zoom', { label: this.state.colour });
  };

  // photo gallery: bottom sheet with scroll-snap swipe + arrows
  KB.prototype.openGallery = function () {
    var d = this.dialog, self = this;
    var imgs = this.galleryFor(this.state.colour);
    if (!imgs.length || !d || d.querySelector('.kb__gal')) return;
    var g = document.createElement('div');
    g.className = 'kb__gal';
    g.innerHTML = '<div class="kb__gal-scrim"></div>' +
      '<div class="kb__gal-sheet">' +
        '<button type="button" class="kb__gal-x" aria-label="Close">✕</button>' +
        '<div class="kb__gal-track">' + imgs.map(function (src, i) {
          return '<div class="kb__gal-slide"><img src="' + src + '"' + (i > 1 ? ' loading="lazy"' : '') + ' alt=""></div>';
        }).join('') + '</div>' +
        '<button type="button" class="kb__gal-arr kb__gal-arr--prev" aria-label="Previous photo" disabled>‹</button>' +
        '<button type="button" class="kb__gal-arr kb__gal-arr--next" aria-label="Next photo">›</button>' +
        '<span class="kb__gal-count">1 / ' + imgs.length + '</span>' +
      '</div>';
    var track = g.querySelector('.kb__gal-track');
    var count = g.querySelector('.kb__gal-count');
    var closeG = function () { g.classList.remove('is-open'); setTimeout(function () { g.remove(); }, 340); };
    g.addEventListener('click', function (ev) {
      if (ev.target.closest('.kb__gal-x') || ev.target.classList.contains('kb__gal-scrim')) { closeG(); return; }
      var arr = ev.target.closest('.kb__gal-arr');
      if (arr) track.scrollBy({ left: (arr.classList.contains('kb__gal-arr--next') ? 1 : -1) * track.clientWidth, behavior: 'smooth' });
    });
    track.addEventListener('scroll', function () {
      var i = Math.max(0, Math.min(imgs.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
      count.textContent = (i + 1) + ' / ' + imgs.length;
      g.querySelector('.kb__gal-arr--prev').disabled = i === 0;
      g.querySelector('.kb__gal-arr--next').disabled = i === imgs.length - 1;
    }, { passive: true });
    d.querySelector('.kb__chrome').appendChild(g);
    requestAnimationFrame(function () { requestAnimationFrame(function () { g.classList.add('is-open'); }); });
    this.track('builder_gallery', { label: this.state.colour });
  };

  KB.prototype.loadVariants = function () {
    var self = this;
    if (Object.keys(this.variantsByHandle).length) return Promise.resolve();
    var all = {}, gal = {};
    function getPage(n, attempt) {
      return fetch('/collections/' + self.collection + '/products.json?limit=250&page=' + n)
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .catch(function (err) {
          if (attempt < 3) {
            self.track('builder_variants_retry', { label: 'p' + n + ' try' + attempt + ' ' + String((err && err.message) || err).slice(0, 60) });
            return new Promise(function (res) { setTimeout(res, 700 * attempt); })
              .then(function () { return getPage(n, attempt + 1); });
          }
          throw err;
        });
    }
    function page(n) {
      return getPage(n, 1)
        .then(function (j) {
          (j.products || []).forEach(function (p) {
            self.pids[p.handle] = p.id;
            gal[p.handle] = (p.images || []).filter(function (im) {
              var f = (im.src.split('/').pop() || '').toLowerCase();
              if (/teaser|swatch|speedshape|gallon|aerosol|logo|icon|banner/.test(f)) return false;
              if (!im.width || !im.height) return false;
              var r = im.width / im.height;
              return r < 0.95 || r > 1.05;   // square = product art, not a car
            }).map(function (im) { return im.src; });
            all[p.handle] = p.variants.map(function (v) {
              return { id: v.id, o1: v.option1 || '', o2: v.option2 || '', o3: v.option3 || '',
                       price: parseFloat(v.price),
                       cap: v.compare_at_price ? parseFloat(v.compare_at_price) : null,
                       available: v.available !== false };
            });
          });
          return (j.products || []).length === 250 ? page(n + 1) : null;
        });
    }
    return page(1).then(function () { self.variantsByHandle = all; self.gallery = gal; })
      .catch(function (err) {
        // out of retries: this session cannot price or add to cart. Previously this
        // catch was empty — the defining failure of the builder was invisible.
        self.track('builder_variants_error', { label: String((err && err.message) || err).slice(0, 80) });
      });
  };

  KB.prototype.essCopy = function (key, dflt) {
    var e = (this.copy || {}).ess || {};
    return (e[key] == null || e[key] === '') ? dflt : e[key];
  };
  KB.prototype.essCount = function () {
    var e = this.state.ess || {};
    return Object.keys(e).reduce(function (n, k) { return n + (e[k] || 0); }, 0);
  };
  KB.prototype.essTotal = function () {
    var e = this.state.ess || {}, sum = 0, cat = this.essCatalog;
    cat.forEach(function (x) { sum += (e[x.id] || 0) * x.p; });
    return sum;
  };

  // project-essentials sheet: steppers over the configured upsell products
  KB.prototype.openEssentials = function () {
    var self = this, d = this.dialog;
    if (!this.essCatalog.length || !d || d.querySelector('.kb__ess')) return;
    var g = document.createElement('div');
    g.className = 'kb__ess';
    var rows = this.essCatalog.map(function (x) {
      var q = (self.state.ess || {})[x.id] || 0;
      return '<div class="kb__ess-row" data-ess-row="' + x.id + '">' +
        '<img src="' + x.img + '" loading="lazy" alt="">' +
        '<span class="kb__ess-txt"><b>' + esc(x.t) + '</b><i>' + money(x.p) + (x.cap > x.p ? ' <s>' + money(x.cap) + '</s>' : '') + '</i></span>' +
        '<span class="kb__ess-step' + (q ? ' has' : '') + '">' +
          '<button type="button" data-ess-minus="' + x.id + '" aria-label="Remove one"' + (q ? '' : ' disabled') + '>−</button>' +
          '<em>' + q + '</em>' +
          '<button type="button" data-ess-plus="' + x.id + '" aria-label="Add one">+</button>' +
        '</span></div>';
    }).join('');
    g.innerHTML = '<div class="kb__ess-scrim"></div>' +
      '<div class="kb__ess-sheet">' +
        '<button type="button" class="kb__gal-x kb__ess-x" aria-label="Close">✕</button>' +
        '<b class="kb__ess-title">' + esc(self.essCopy('title', 'Project Essentials')) + '</b>' +
        '<p class="kb__ess-sub">' + esc(self.essCopy('sub', 'Pro-recommended extras for a clean, easy job.')) + '</p>' +
        '<div class="kb__ess-rows">' + rows + '</div>' +
        '<button type="button" class="kb__ess-done" data-ess-done>Done</button>' +
      '</div>';
    var syncDone = function () {
      var n = self.essCount();
      g.querySelector('.kb__ess-done').textContent = n ? 'Done · ' + n + ' added · ' + money(self.essTotal()) : 'Done';
    };
    syncDone();
    var closeE = function () { g.classList.remove('is-open'); setTimeout(function () { g.remove(); }, 320); self.syncHash(); self.render(); };
    g.addEventListener('click', function (ev) {
      if (ev.target.closest('.kb__ess-x') || ev.target.closest('[data-ess-done]') || ev.target.classList.contains('kb__ess-scrim')) { closeE(); return; }
      var plus = ev.target.closest('[data-ess-plus]'), minus = ev.target.closest('[data-ess-minus]');
      if (!plus && !minus) return;
      var id = (plus || minus).getAttribute(plus ? 'data-ess-plus' : 'data-ess-minus');
      var e = self.state.ess = self.state.ess || {};
      e[id] = Math.max(0, (e[id] || 0) + (plus ? 1 : -1));
      if (!e[id]) delete e[id];
      self.track(plus ? 'builder_ess_add' : 'builder_ess_remove', { label: id });
      var row = g.querySelector('[data-ess-row="' + id + '"]');
      var q = e[id] || 0;
      row.querySelector('em').textContent = q;
      row.querySelector('[data-ess-minus]').disabled = !q;
      row.querySelector('.kb__ess-step').classList.toggle('has', !!q);
      syncDone();
    });
    d.querySelector('.kb__chrome').appendChild(g);
    requestAnimationFrame(function () { requestAnimationFrame(function () { g.classList.add('is-open'); }); });
    this.track('builder_ess_open', {});
  };

  // fully out of stock = every variant of the kit unavailable
  KB.prototype.kitOut = function (h) {
    var vars = this.variantsByHandle[h];
    return !!(vars && vars.length && vars.every(function (v) { return !v.available; }));
  };
  // best-representative variant for a restock alert (ignores availability)
  KB.prototype.alertVariant = function (h) {
    var st = this.state, vars = this.variantsByHandle[h] || [];
    var veh = VEHICLES.find(function (v) { return v.key === st.vehicle; });
    var hit = vars.find(function (v) { return veh && v.o1.toLowerCase() === veh.opt.toLowerCase(); });
    return hit || vars[0] || null;
  };

  // "out of stock" drawer: email capture -> AMP Back in Stock
  KB.prototype.openOOS = function (handle, force) {
    var self = this, d = this.dialog;
    var c = this.colourOf(handle);
    if (!c || !d || d.querySelector('.kb__oos')) return;
    this.oosShown = this.oosShown || {};
    if (this.oosShown[handle] && !force) return;
    this.oosShown[handle] = true;
    var g = document.createElement('div');
    g.className = 'kb__oos';
    g.innerHTML = '<div class="kb__oos-scrim"></div>' +
      '<div class="kb__oos-sheet">' +
        '<button type="button" class="kb__gal-x kb__oos-x" aria-label="Close">✕</button>' +
        '<b class="kb__oos-title">' + c.title + ' is out of stock</b>' +
        '<p class="kb__oos-sub">Leave your email and we\'ll let you know the moment it\'s back.</p>' +
        '<form class="kb__oos-form" novalidate>' +
          '<input type="email" name="email" required placeholder="you@email.com" autocomplete="email" inputmode="email">' +
          '<button type="submit">Email me when it\'s back</button>' +
        '</form>' +
        '<span class="kb__oos-fine">One email when it restocks. No spam, no lists.</span>' +
      '</div>';
    var closeO = function () { g.classList.remove('is-open'); setTimeout(function () { g.remove(); }, 320); };
    g.addEventListener('click', function (ev) {
      if (ev.target.closest('.kb__oos-x') || ev.target.classList.contains('kb__oos-scrim')) closeO();
    });
    g.querySelector('form').addEventListener('submit', function (ev) {
      ev.preventDefault();
      var input = g.querySelector('input');
      var email = (input.value || '').trim();
      if (!email || email.indexOf('@') < 1) { input.focus(); return; }
      var btn = g.querySelector('form button');
      btn.disabled = true; btn.textContent = 'Adding you…';
      var v = self.alertVariant(handle);
      var params = new URLSearchParams({
        'shop': 'dipyourcar-com.myshopify.com',
        'notification[email]': email,
        'notification[product_no]': String(self.pids[handle] || ''),
        'notification[quantity_required]': '1',
        'notification[accepts_marketing]': 'false',
        'notification[customer_utc_offset]': String(-new Date().getTimezoneOffset() * 60)
      });
      if (v) params.set('variant[variant_no]', String(v.id));
      fetch('https://app.backinstock.org/stock_notification/create.json?' + params.toString())
        .then(function (r) { return r.json(); })
        .then(function (j) {
          if (j.status === 'OK') {
            self.track('builder_oos_signup', { label: handle });
            g.querySelector('.kb__oos-sheet').innerHTML =
              '<button type="button" class="kb__gal-x kb__oos-x" aria-label="Close">✕</button>' +
              '<b class="kb__oos-title">You\'re on the list ✓</b>' +
              '<p class="kb__oos-sub">We\'ll email you the moment ' + c.title + ' is back in stock.</p>';
          } else {
            var msg = (j.errors && j.errors.email && j.errors.email[0]) || 'That didn\'t work — check the email and try again.';
            btn.disabled = false; btn.textContent = 'Email me when it\'s back';
            var fine = g.querySelector('.kb__oos-fine');
            if (fine) { fine.textContent = msg; fine.style.color = '#bf1213'; }
          }
        })
        .catch(function () { btn.disabled = false; btn.textContent = 'Email me when it\'s back'; });
    });
    d.querySelector('.kb__chrome').appendChild(g);
    requestAnimationFrame(function () { requestAnimationFrame(function () { g.classList.add('is-open'); }); });
    this.track('builder_oos_shown', { label: handle });
  };

  KB.prototype.variantFor = function (handle) {
    var st = this.state;
    var vars = this.variantsByHandle[handle];
    if (!vars) return null;
    var veh = VEHICLES.find(function (v) { return v.key === st.vehicle; });
    var spr = SPRAYERS.find(function (x) { return x.key === st.sprayer; });
    var fin = FINISHES.find(function (f) { return f.key === st.finish; });
    var best = null;
    vars.forEach(function (v) {
      if (!v.available) return;
      if (veh && v.o1.toLowerCase() !== veh.opt.toLowerCase()) return;
      if (spr && !spr.match.test(v.o2)) return;
      if (fin && !fin.match.test(v.o3)) return;
      if (!best) best = v;
    });
    return best;
  };

  // side-by-side compare drawer: up to 3 colours under the current build
  KB.prototype.openCompare = function () {
    var self = this, d = this.dialog;
    if (this.compare.length < 2 || !d || d.querySelector('.kb__cmp')) return;
    var cols = this.compare.map(function (h) { return self.colourOf(h); }).filter(Boolean);
    var g = document.createElement('div');
    g.className = 'kb__cmp';
    g.innerHTML = '<div class="kb__cmp-scrim"></div>' +
      '<div class="kb__cmp-sheet">' +
        '<button type="button" class="kb__gal-x kb__cmp-x" aria-label="Close">✕</button>' +
        '<b class="kb__cmp-title">Side by side</b>' +
        '<div class="kb__cmp-grid kb__cmp-grid--n' + cols.length + '">' +
        cols.map(function (c) {
          var v = self.variantFor(c.handle);
          var rt = self.ratingFor(c.handle);
          var shape = (self.state.finish === 'uhg' ? (c.gloss || c.matte) : (c.matte || c.gloss)) || c.img || '';
          var cars = self.galleryFor(c.handle).slice(0, 2);
          var traits = [['Family', c.cf], ['Type', c.style], ['Series', c.klass],
            ['Pearl stage', /^yes$/i.test(c.pearl || '') ? 'Yes' : 'No']].filter(function (t) { return t[1]; });
          return '<div class="kb__cmp-col">' +
            (shape ? '<img class="kb__cmp-shape" src="' + shape + '" loading="lazy" alt="" data-cmp-zoom="' + shape + '">' : '') +
            '<b>' + c.title + '</b>' +
            '<i class="kb__cmp-stars">' + (rt ? '★ ' + rt.r.toFixed(1) + ' (' + rt.n + ')' : '') + '</i>' +
            '<em class="kb__cmp-price">' + (v ? money(v.price) : 'Pick options first') + '</em>' +
            '<span class="kb__cmp-traits">' + traits.map(function (t) {
              return '<span><i>' + t[0] + '</i><b>' + t[1] + '</b></span>'; }).join('') + '</span>' +
            (cars.length ? '<span class="kb__cmp-cars">' + cars.map(function (src) {
              return '<img src="' + src + '" loading="lazy" alt="" data-cmp-zoom="' + src + '">'; }).join('') + '</span>' : '') +
            '<button type="button" class="kb__cmp-pick" data-cmp-pick="' + c.handle + '">Select</button>' +
          '</div>';
        }).join('') + '</div>' +
      '</div>';
    var closeC = function () { g.classList.remove('is-open'); setTimeout(function () { g.remove(); }, 320); };
    g.addEventListener('click', function (ev) {
      if (ev.target.closest('.kb__cmp-x') || ev.target.classList.contains('kb__cmp-scrim')) { closeC(); return; }
      var z = ev.target.closest('[data-cmp-zoom]');
      if (z) {
        var zoom = document.createElement('div');
        zoom.className = 'kb__zoom';
        zoom.innerHTML = '<img src="' + z.getAttribute('data-cmp-zoom') + '" alt="">';
        zoom.addEventListener('click', function () { zoom.classList.remove('is-open'); setTimeout(function () { zoom.remove(); }, 260); });
        d.querySelector('.kb__chrome').appendChild(zoom);
        requestAnimationFrame(function () { requestAnimationFrame(function () { zoom.classList.add('is-open'); }); });
        return;
      }
      var pick = ev.target.closest('[data-cmp-pick]');
      if (pick) {
        self.state.colour = pick.getAttribute('data-cmp-pick');
        self.track('builder_compare_pick', { label: self.state.colour });
        self.exitCompare();
        closeC();
        self.syncHash();
        self.render(self.state.step === 2 ? { keepBody: true } : undefined);
        if (self.state.step === 2) {
          d.querySelectorAll('.kb__sw').forEach(function (b) {
            b.classList.toggle('on', b.getAttribute('data-kb-val') === self.state.colour);
          });
        }
        if (self.kitOut(self.state.colour)) self.openOOS(self.state.colour);
      }
    });
    cols.forEach(function (c) { self.fetchRating(c.handle); });
    d.querySelector('.kb__chrome').appendChild(g);
    requestAnimationFrame(function () { requestAnimationFrame(function () { g.classList.add('is-open'); }); });
    this.track('builder_compare_open', { label: this.compare.join(',') });
  };

  KB.prototype.exitCompare = function () {
    this.compareMode = false;
    this.compare = [];
    var d = this.dialog;
    if (!d) return;
    var strip = d.querySelector('.kb__cmpbar');
    if (strip) strip.remove();
    d.querySelectorAll('.kb__sw--cmp').forEach(function (b) { b.classList.remove('kb__sw--cmp'); });
    d.classList.remove('kb--comparing');
  };

  KB.prototype.updateCompareBar = function () {
    var d = this.dialog, self = this;
    var strip = d.querySelector('.kb__cmpbar');
    if (!this.compareMode) { if (strip) strip.remove(); return; }
    if (!strip) {
      strip = document.createElement('div');
      strip.className = 'kb__cmpbar';
      d.querySelector('.kb__main').insertBefore(strip, d.querySelector('.kb__body'));
    }
    var chips = this.compare.map(function (h) {
      var c = self.colourOf(h);
      var t = c && (c.thumb || c.matte || c.img);
      return '<button type="button" class="kb__cmpbar-sw" data-cmp-remove="' + h + '" aria-label="Remove ' + (c ? c.title : '') + '">' +
        (t ? '<img src="' + t + '" alt="">' : '') + '<i>✕</i></button>';
    }).join('');
    strip.innerHTML = '<span class="kb__cmpbar-hint">' +
      (this.compare.length ? chips : 'Tap up to 3 colors to compare') + '</span>' +
      '<button type="button" class="kb__cmpbar-go" data-kb-compare-view' + (this.compare.length < 2 ? ' disabled' : '') + '>Compare' + (this.compare.length ? ' (' + this.compare.length + ')' : '') + '</button>' +
      '<button type="button" class="kb__cmpbar-exit" data-kb-compare-exit aria-label="Exit compare">✕</button>';
  };

  KB.prototype.matchedVariant = function () {
    var st = this.state;
    var vars = this.variantsByHandle[st.colour];
    if (!vars) return null;
    var veh = VEHICLES.find(function (v) { return v.key === st.vehicle; });
    var spr = SPRAYERS.find(function (s) { return s.key === st.sprayer; });
    var fin = FINISHES.find(function (f) { return f.key === st.finish; });
    var best = null;
    vars.forEach(function (v) {
      if (!v.available) return;
      if (veh && v.o1.toLowerCase() !== veh.opt.toLowerCase()) return;
      if (spr && !spr.match.test(v.o2)) return;
      if (fin && !fin.match.test(v.o3)) return;
      if (!best || v.price < best.price) best = v;
    });
    return best;
  };

  KB.prototype.syncHash = function () {
    var s = this.state;
    history.replaceState(null, '', '#kb=' + btoa(JSON.stringify(
      { step: s.step, vehicle: s.vehicle, colour: s.colour, sprayer: s.sprayer, finish: s.finish,
        ess: (s.ess && Object.keys(s.ess).length) ? s.ess : undefined })));
  };
  KB.prototype.track = function (n, p) {
    // The landing page loads this script BEFORE dyc-analytics.js, so events fired
    // during auto-open (campaign URLs, hash resume) used to vanish: zero campaign-url
    // builder_open was ever recorded despite paid orders carrying that entry tag.
    // Hold the event and retry for up to 6s instead of dropping it.
    p = p || {};
    var tries = p.__t || 0;
    if (!tries) { try { if (window.gtag) gtag('event', n, p); } catch (e) {} }
    if (window.DYCAnalytics) {
      delete p.__t;
      try { window.DYCAnalytics.trackCustom('kit_builder', n, p.label || '', p); } catch (e) {}
    } else if (tries < 24) {
      p.__t = tries + 1;
      var self = this;
      setTimeout(function () { self.track(n, p); }, 250);
    }
  };
  // sale-aware price HTML: strikethrough compare-at + save badge, mirroring the PDP
  // the CURRENT build's component lines (colour × size × sprayer × finish)
  KB.prototype.buildItems = function () {
    var st = this.state;
    var c = this.colourOf(st.colour);
    var veh = VEHICLES.find(function (x) { return x.key === st.vehicle; });
    if (!c || !veh || !c.kc || !c.kc[veh.opt]) return null;
    function fmt(it) {
      var u = (it.u || '').toLowerCase();
      if (u.indexOf('gallon') === 0) return it.q + ' x ' + it.n + (it.q === 1 ? ' Gallon' : ' Gallons');
      if (u.indexOf('quart') === 0) return it.q + ' x ' + it.n + (it.q === 1 ? ' Quart' : ' Quarts');
      if (u.indexOf('liter') === 0) return it.q + ' x ' + it.n + (it.q === 1 ? ' Liter' : ' Liters');
      if (u === 'g' || u.indexOf('g ') === 0 || u.indexOf('g(') === 0 || u.indexOf('pearl') >= 0) return it.q + 'g ' + it.n;
      return it.q + ' x ' + it.n;
    }
    var lines = c.kc[veh.opt].map(fmt);
    if (st.sprayer === 'gforce') lines.push('1 x G-Force DipSprayer System');
    if (st.sprayer === 'ultimate') lines.push('1 x Ultimate DipSprayer System');
    if (st.finish === 'uhg') lines.push((veh.key === 'xl' ? 2 : 1) + ' x Ultra High Gloss Topcoat');
    lines.push('1 x Pack Accessory Bundle');
    return lines;
  };
  // dynamic box header + paint lines for the CURRENT build (colour × size × sprayer × finish)
  KB.prototype.boxHTML = function () {
    var st = this.state;
    var c = this.colourOf(st.colour);
    var veh = VEHICLES.find(function (x) { return x.key === st.vehicle; });
    if (!c || !veh || !c.kc || !c.kc[veh.opt]) {
      return '<h3>' + this.boxMeta.title + '</h3><p>' + this.boxMeta.sub + '</p>';
    }
    function fmt(it) {
      var u = (it.u || '').toLowerCase();
      // volume units first — "gallons" must not fall into the grams branch
      if (u.indexOf('gallon') === 0) return it.q + ' × ' + it.n + (it.q === 1 ? ' Gallon' : ' Gallons');
      if (u.indexOf('quart') === 0) return it.q + ' × ' + it.n + (it.q === 1 ? ' Quart' : ' Quarts');
      if (u.indexOf('liter') === 0) return it.q + ' × ' + it.n + (it.q === 1 ? ' Liter' : ' Liters');
      if (u === 'g' || u.indexOf('g ') === 0 || u.indexOf('g(') === 0 || u.indexOf('pearl') >= 0) return it.q + 'g ' + it.n;
      return it.q + ' × ' + it.n;
    }
    var items = c.kc[veh.opt].map(function (it) {
      var u = (it.u || '').toLowerCase();
      var qty = (u === 'g' || u.indexOf('g ') === 0 || u.indexOf('g(') === 0 || u.indexOf('pearl') >= 0)
        ? it.q + 'g' : '×' + it.q;
      var img = it.i ? it.i + (it.i.indexOf('?') >= 0 ? '&' : '?') + 'width=180' : '';
      return { t: fmt(it), qty: qty, img: img };
    });
    if (st.sprayer === 'gforce') items.push({ t: 'G-Force DipSprayer System', qty: '×1', img: this.imgs.gforce || '' });
    if (st.sprayer === 'ultimate') items.push({ t: 'Ultimate DipSprayer System', qty: '×1', img: this.imgs.ultimate || '' });
    if (st.finish === 'uhg') items.push({ t: 'Ultra High Gloss Topcoat', qty: '×' + (veh.key === 'xl' ? 2 : 1), img: (c.gloss || '') });
    return '<h3>Your ' + c.title + ' kit — ' + veh.label + '</h3>' +
      '<p>Updates as you build.</p>' +
      '<div class="kb__box-dyn">' + items.map(function (it) {
        return '<div class="kb__box-dynitem">' +
          (it.img ? '<span class="kb__box-dynimg"><img src="' + it.img + '" loading="lazy" alt=""><i>' + it.qty + '</i></span>'
                  : '<span class="kb__box-dynimg kb__box-dynimg--ph"><i>' + it.qty + '</i></span>') +
          '<span>' + it.t + '</span></div>';
      }).join('') + '</div>' +
      '<p class="kb__box-divider">plus the essentials</p>';
  };
  KB.prototype.priceHTML = function (v, compact) {
    if (!v) return '—';
    if (v.cap && v.cap > v.price) {
      var pct = Math.round((1 - v.price / v.cap) * 100);
      return '<s>' + money(v.cap) + '</s> <em>' + money(v.price) + '</em><i class="kb__save">' + (compact ? '' : 'SAVE ') + pct + '%</i>';
    }
    return money(v.price);
  };

  KB.prototype.build = function () {
    var self = this;
    var d = document.createElement('dialog');
    d.className = 'kb';
    d.innerHTML =
      '<div class="kb__chrome">' +
        '<button type="button" class="kb__searchbtn" data-kb-search aria-label="Search colors">' +
          '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.8-3.8"/></svg>' +
        '</button>' +
        '<button type="button" class="kb__x" data-kb-close aria-label="Close">✕</button>' +
        '<div class="kb__rail">' +
          '<div class="kb__rail-video" hidden></div>' +
          '<div class="kb__rail-meta">' +
            '<span class="kb__rail-num"></span>' +
            '<h3 class="kb__rail-name"></h3>' +
            '<p class="kb__rail-sub"></p>' +
            '<div class="kb__rail-tip" hidden><span class="kb__rail-f">F</span><p></p></div>' +
          '</div>' +
        '</div>' +
        '<div class="kb__hero">' +
          '<div class="kb__hero-img"><img alt="" hidden></div>' +
          '<div class="kb__hero-badges"></div>' +
          '<div class="kb__hero-actions"></div>' +
        '</div>' +
        '<div class="kb__main">' +
          '<div class="kb__nav"></div>' +
          '<div class="kb__tip" hidden><span class="kb__tip-badge">F</span><p class="kb__tip-text"></p></div>' +
          '<div class="kb__body"></div>' +
        '</div>' +
        '<div class="kb__foot">' +
          '<button type="button" class="kb__wib" data-kb-box-open>' + BOX_ICON +
            '<i class="kb__wib-tag">Kit</i><span>What\'s in the box</span></button>' +
          '<div class="kb__total"><span class="kb__total-note"></span><b class="kb__total-amt"></b></div>' +
          '<button type="button" class="kb__next" data-kb-next>Next</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(d);
    this.dialog = d;

    d.addEventListener('click', function (e) {
      if (e.target.closest('[data-kb-close]') || e.target === d) { self.close(); return; }
      var go = e.target.closest('[data-kb-go]');
      if (go && !go.disabled) { self.state.step = +go.getAttribute('data-kb-go'); self.track('builder_nav', { label: 'chip:' + self.state.step }); self.syncHash(); self.render(); return; }
      var flt = e.target.closest('[data-kb-filter]');
      if (flt) { self.state.filter = flt.getAttribute('data-kb-filter'); self.render(); return; }
      if (e.target.closest('[data-kb-view]')) {
        self.state.view = self.state.view === 'render' ? 'shape' : 'render';
        self.track('builder_ai_render', { label: self.state.view === 'render' ? 'on' : 'off' });
        self.render(); return;
      }
      var openSheet = d.querySelector('.kb__box.is-open, .kb__specs.is-open');
      if (openSheet && !e.target.closest('.kb__box') && !e.target.closest('.kb__specs') &&
          !e.target.closest('[data-kb-box-open]') && !e.target.closest('[data-kb-specs]')) {
        openSheet.classList.remove('is-open');
        setTimeout(function () { openSheet.remove(); }, 320);
        return;
      }
      if (e.target.closest('[data-kb-compare-toggle]')) {
        self.compareMode = !self.compareMode;
        d.classList.toggle('kb--comparing', self.compareMode);
        if (!self.compareMode) { self.exitCompare(); } else { self.updateCompareBar(); }
        return;
      }
      if (e.target.closest('[data-kb-compare-view]')) { self.openCompare(); return; }
      if (e.target.closest('[data-kb-compare-exit]')) { self.exitCompare(); return; }
      var cmpRm = e.target.closest('[data-cmp-remove]');
      if (cmpRm) {
        self.compare = self.compare.filter(function (h) { return h !== cmpRm.getAttribute('data-cmp-remove'); });
        var swEl = d.querySelector('.kb__sw[data-kb-val="' + cmpRm.getAttribute('data-cmp-remove') + '"]');
        if (swEl) swEl.classList.remove('kb__sw--cmp');
        self.updateCompareBar();
        return;
      }
      if (e.target.closest('[data-kb-search]')) { self.openSearch(); return; }
      if (e.target.closest('.kb__hero-img img')) { self.openZoom(); return; }
      if (e.target.closest('[data-kb-gal]')) { self.openGallery(); return; }
      if (e.target.closest('[data-kb-oos]')) { self.openOOS(self.state.colour, true); return; }
      if (e.target.closest('[data-kb-ess-open]')) { self.openEssentials(); return; }
      if (e.target.closest('[data-kb-box-open]')) {
        if (!self.box.length || d.querySelector('.kb__box')) return;
        var bx = document.createElement('div');
        bx.className = 'kb__box';
        bx.innerHTML = '<button type="button" class="kb__box-x" aria-label="Close">✕</button>' +
          self.boxHTML() +
          '<div class="kb__box-grid">' + self.box.map(function (it) {
            return '<div class="kb__box-item"><img src="' + it.img + '" loading="lazy" alt=""><span>' + it.title + '</span></div>';
          }).join('') + '</div>';
        var closeBx = function () { bx.classList.remove('is-open'); setTimeout(function () { bx.remove(); }, 320); };
        bx.addEventListener('click', function (ev) {
          if (ev.target.closest('.kb__box-x')) closeBx();
        });
        d.querySelector('.kb__main').appendChild(bx);
        requestAnimationFrame(function () { requestAnimationFrame(function () { bx.classList.add('is-open'); }); });
        self.track('builder_box_open', {});
        return;
      }
      if (e.target.closest('[data-kb-video]')) {
        var ov = document.createElement('div');
        ov.className = 'kb__video';
        ov.innerHTML = '<video src="' + self.demoVideo + '" controls autoplay playsinline></video>' +
          '<button type="button" class="kb__video-x" aria-label="Close video">✕</button>';
        ov.addEventListener('click', function (ev) {
          if (ev.target === ov || ev.target.closest('.kb__video-x')) { ov.querySelector('video').pause(); ov.remove(); }
        });
        d.querySelector('.kb__chrome').appendChild(ov);
        self.track('builder_video_open', {});
        return;
      }
      if (e.target.closest('[data-kb-ainote]')) {
        var host = d.querySelector('.kb__chrome');
        if (host.querySelector('.kb__specs')) return;
        var an = document.createElement('div');
        an.className = 'kb__specs';
        an.innerHTML = '<button type="button" class="kb__specs-x" aria-label="Close">✕</button>' +
          '<b>About this preview</b>' +
          '<p class="kb__specs-p">This preview is a digital render created from our color data to give you a feel for the finish on a vehicle like yours. It is not a photograph.</p>' +
          '<p class="kb__specs-p">Real-world results vary with lighting, base color, coats and technique. The speed shape photo shows the actual sprayed color.</p>';
        an.addEventListener('click', function (ev) { if (ev.target.closest('.kb__specs-x')) { an.classList.remove('is-open'); setTimeout(function () { an.remove(); }, 280); } });
        host.appendChild(an);
        requestAnimationFrame(function () { requestAnimationFrame(function () { an.classList.add('is-open'); }); });
        self.track('builder_ainote_open', {});
        return;
      }
      if (e.target.closest('[data-kb-specs]')) {
        var hero = d.querySelector('.kb__chrome');
        var cc = self.colourOf(self.state.colour);
        if (!cc || hero.querySelector('.kb__specs')) return;
        var rows = [
          ['Color family', cc.cf], ['Type', cc.style], ['Series', cc.klass],
          ['Pearl topcoat stage', /^yes$/i.test(cc.pearl) ? 'Yes — sprayed over the basecoat' : 'Not needed'],
          ['Recommended basecoat', cc.base],
          ['Finishes Available', (cc.matte ? self.stdFinishLabel(cc) : '') + (cc.gloss ? (cc.matte ? ' · ' : '') + 'Ultra High Gloss' : '')]
        ].filter(function (r) { return r[1]; });
        var sp = document.createElement('div');
        sp.className = 'kb__specs';
        sp.innerHTML = '<button type="button" class="kb__specs-x" aria-label="Close">✕</button>' +
          '<b>' + cc.title + '</b>' +
          rows.map(function (r) { return '<div class="kb__specs-row"><span>' + r[0] + '</span><em>' + r[1] + '</em></div>'; }).join('') +
          (self.state.view === 'render' && self.renderSrc(cc)
            ? '<p class="kb__specs-p" style="margin-top:10px"><strong>About the car preview.</strong> A digital render from our color data, not a photograph. Real results vary with lighting, base color, coats and technique; the speed shape shows the actual sprayed color.</p>'
            : '');
        sp.addEventListener('click', function (ev) { if (ev.target.closest('.kb__specs-x')) { sp.classList.remove('is-open'); setTimeout(function () { sp.remove(); }, 280); } });
        hero.appendChild(sp);
        requestAnimationFrame(function () { requestAnimationFrame(function () { sp.classList.add('is-open'); }); });
        self.track('builder_specs_open', {});
        return;
      }
      var cflt = e.target.closest('[data-kb-cfilter]');
      if (cflt) { self.state.cfilter = cflt.getAttribute('data-kb-cfilter'); self.track('builder_filter', { label: self.state.cfilter }); self.render(); return; }
      var opt = e.target.closest('[data-kb-pick]');
      if (opt && self.compareMode && opt.getAttribute('data-kb-pick') === 'colour') {
        var ch = opt.getAttribute('data-kb-val');
        var i = self.compare.indexOf(ch);
        if (i !== -1) { self.compare.splice(i, 1); opt.classList.remove('kb__sw--cmp'); }
        else if (self.compare.length < 3) { self.compare.push(ch); opt.classList.add('kb__sw--cmp'); }
        self.updateCompareBar();
        return;
      }
      if (opt) {
        var kind = opt.getAttribute('data-kb-pick');
        self.state[kind] = opt.getAttribute('data-kb-val');
        self.track('builder_pick', { label: kind + ':' + self.state[kind], step: self.state.step, skin: self.mode });
        if (kind === 'colour' && self.kitOut(self.state.colour)) self.openOOS(self.state.colour);
        // no step ever advances on selection — Next is always the driver.
        // Colour picks on the swatch grid update in place: the grid is never
        // rebuilt, so the scroll position physically cannot move.
        if (kind === 'colour' && self.state.step === 2) {
          d.querySelectorAll('.kb__sw').forEach(function (b) {
            b.classList.toggle('on', b.getAttribute('data-kb-val') === self.state.colour);
          });
          self.syncHash();
          self.render({ keepBody: true });
          return;
        }
        self.syncHash(); self.render();
        return;
      }
      if (e.target.closest('[data-kb-change]')) { self.track('builder_color_change', { label: 'from:' + self.state.step }); self.state.step = 2; self.syncHash(); self.render(); return; }
      if (e.target.closest('[data-kb-next]')) { self.track('builder_nav', { label: 'next:' + self.state.step }); self.next(); return; }
      if (e.target.closest('[data-kb-atc]')) { self.addToCart(); return; }
      if (e.target.closest('[data-kb-checkout]')) { self.addToCart(true); return; }
    });
    d.addEventListener('close', function () { document.documentElement.style.overflow = ''; });
    // colour step, mobile: collapse the stage while browsing swatches, restore near the top
    var body = d.querySelector('.kb__body');
    body.addEventListener('scroll', function () {
      if (self.state.step !== 2 || window.innerWidth >= 900) return;
      var t = body.scrollTop;
      var want = t > 56 ? true : (t < 12 ? false : null);
      if (want === null || d.classList.contains('kb--navhide') === want) return;
      d.classList.toggle('kb--navhide', want);
    }, { passive: true });
  };

  // the ACTIVE step sequence: color drops out for preselected entries, finish
  // drops out for the beginner preset. Internal step ids never change.
  KB.prototype.seq = function () {
    var s = [1];
    if (!(this.skipColor && this.state.colour)) s.push(2);
    s.push(3);
    if (this.preset !== 'beginner') s.push(4);
    s.push(5);
    return s;
  };
  // display sequence: when the customer explicitly visits the color step, it
  // rejoins the numbering for the duration of the visit
  KB.prototype.dseq = function () {
    var q = this.seq();
    if (this.state.step === 2 && q.indexOf(2) === -1) q = q.slice(0, 1).concat([2], q.slice(1));
    return q;
  };
  KB.prototype.next = function () {
    var need = { 1: 'vehicle', 2: 'colour', 3: 'sprayer', 4: 'finish' }[this.state.step];
    if (need && !this.state[need]) return;
    var q = this.seq(), st = this.state, nxt = null;
    for (var i = 0; i < q.length; i++) if (q[i] > st.step) { nxt = q[i]; break; }
    if (nxt == null) return;
    if (nxt === 5 && !st.finish) st.finish = 'satin';
    st.step = nxt;
    this.syncHash(); this.render();
  };

  KB.prototype.render = function (opts) {
    var self = this, st = this.state, d = this.dialog;

    // hero — mobile: morphs open on the colour step only.
    // desktop: the same column is an ink rail on meta steps, the paint stage on colour.
    d.classList.toggle('kb--stage', st.step === 2);
    d.classList.toggle('kb--sum', st.step === 5);
    if (st.step !== 2) { d.classList.remove('kb--shrunk'); d.classList.remove('kb--navhide'); if (this.compareMode) this.exitCompare(); }
    d.classList.toggle('kb--center', st.step === 3 || st.step === 4);
    var SUBS = { 1: 'Sets how much paint arrives.', 2: '', 3: '',
                 4: 'Your color, in both finishes.', 5: 'Everything arrives in one box.' };
    d.querySelector('.kb__rail-num').textContent = '0' + (this.dseq().indexOf(st.step) + 1);
    d.querySelector('.kb__rail-name').textContent = STEPS[st.step - 1];
    d.querySelector('.kb__rail-sub').textContent = this.stepCopy(st.step, 'rail', SUBS[st.step] || '');
    var railMeta = d.querySelector('.kb__rail-meta');
    var rcNode = railMeta.querySelector('.kb__rail-color');
    var cSel = this.skipColor && st.colour && this.colourOf(st.colour);
    if (cSel && st.step !== 2 && st.step !== 5) {
      var rct = cSel.thumb || cSel.matte || cSel.img;
      if (!rcNode) { rcNode = document.createElement('div'); rcNode.className = 'kb__rail-color'; railMeta.appendChild(rcNode); }
      rcNode.innerHTML = '<span class="kb__rail-ctile">' + (rct ? '<img src="' + rct + '" alt="">' : '') + '</span>' +
        '<span class="kb__rail-clabel">Your color</span>' +
        '<b class="kb__rail-cname">' + esc(cSel.title) + ' <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="#17a673" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg></b>' +
        '<button type="button" class="kb__rail-cchange" data-kb-change>Change color</button>';
    } else if (rcNode) rcNode.remove();
    var railVid = d.querySelector('.kb__rail-video');
    if (this.demoVideo) {
      railVid.hidden = false;
      if (!railVid.querySelector('video')) {
        railVid.innerHTML = '<video src="' + this.demoVideo + '" playsinline preload="metadata"></video>' +
          '<button type="button" class="kb__rail-video-tap" data-kb-video aria-label="Watch video"></button>';
        var vv = railVid.querySelector('video');
        if (window.innerWidth >= 900) { vv.setAttribute('controls', ''); }
        else { vv.muted = true; vv.loop = true; vv.autoplay = true; vv.play().catch(function () {}); }
      }
    } else { railVid.hidden = true; }
    var railTip = d.querySelector('.kb__rail-tip');
    if (this.mode === 'fonzie') { railTip.hidden = false; railTip.querySelector('p').textContent = TIPS[st.step]; }
    else railTip.hidden = true;
    var c = this.colourOf(st.colour);
    var img = d.querySelector('.kb__hero img');
    var ai = this.renderSrc(c);
    var shape = this.heroSrc(c);
    var src = (st.view === 'render' && ai) ? ai : shape;
    if (!src) { // default render: Matte Black's speed shape
      var def = this.colourOf('matte-black-car-kit') || this.catalog[0];
      src = def ? (def.matte || def.img) : null;
    }
    if (src) {
      img.onerror = shape && src !== shape ? function () { img.onerror = null; img.src = shape; img.classList.remove('is-render'); } : null;
      img.src = src; img.hidden = false;
      img.classList.toggle('is-render', st.view === 'render' && src === ai);
    } else { img.hidden = true; }
    // hero action buttons: AI render toggle + demo video
    var acts = d.querySelector('.kb__hero-actions');
    acts.innerHTML =
      (ai ? '<button type="button" data-kb-view class="' + (st.view === 'render' ? 'on' : '') + '" title="See it on a car" aria-label="Toggle car render">' + AI_ICON + '</button>' : '');
    var hb = d.querySelector('.kb__hero-badges');
    var showingAI = st.view === 'render' && !!ai;
    var galArr = c ? this.galleryFor(c.handle) : [];
    if (c) this.fetchRating(c.handle);
    var rt = c ? this.ratingFor(c.handle) : null;
    if (c) {
      hb.innerHTML = '<span class="kb__hero-title">' + c.title +
        (rt ? ' <i class="kb__stars">★ ' + rt.r.toFixed(1) + ' (' + rt.n + ')</i>' : '') + '</span>' +
        (ai ? '<button type="button" class="kb__moreinfo kb__moreinfo--view" data-kb-view>' + AI_ICON + ' ' + (showingAI ? 'Shape' : 'On a car') + '</button>' : '') +
        (galArr.length ? '<button type="button" class="kb__moreinfo kb__moreinfo--gal" data-kb-gal aria-label="Photo gallery">' + GAL_ICON + '</button>' : '') +
        (st.step === 2 ? '<button type="button" class="kb__moreinfo kb__moreinfo--cmp" data-kb-compare-toggle aria-label="Compare colors">' +
          '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><rect x="3" y="4" width="7" height="16" rx="1.5"/><rect x="14" y="4" width="7" height="16" rx="1.5"/></svg> Compare</button>' : '') +
        (showingAI ? '<button type="button" class="kb__ainote kb__ainote--mini" data-kb-ainote aria-label="About this render">ⓘ</button>' : '') +
        '<button type="button" class="kb__moreinfo" data-kb-specs>' +
        '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/></svg>' +
        ' More info</button>';
    } else {
      hb.innerHTML = '<span>Pick a color to see it here</span>';
    }
    var oldSpecs = d.querySelector('.kb__specs'); if (oldSpecs) oldSpecs.remove();
    var wib = d.querySelector('.kb__wib');
    if (wib) wib.style.display = st.colour ? '' : 'none';

    // step chips: reachable = every step up to the first incomplete one
    var reach = 1;
    if (st.vehicle) reach = 2; if (st.vehicle && st.colour) reach = 3;
    if (st.vehicle && st.colour && st.sprayer) reach = 4;
    if (st.vehicle && st.colour && st.sprayer && st.finish) reach = 5;
    var dq = this.dseq();
    d.querySelector('.kb__nav').innerHTML = STEPS.map(function (name, i) {
      var n = i + 1;
      // Summary chip earns its place only once the build is complete
      if (n === 5 && reach < 5 && st.step !== 5) return '';
      if (n === 4 && self.preset === 'beginner') return '';
      if (dq.indexOf(n) === -1) return '';
      var disp = dq.indexOf(n) + 1;
      var cls = n === st.step ? 'now' : (n <= reach ? 'done' : '');
      var compress = reach >= 5 && window.innerWidth < 900;
      var label = n === 5 ? '✓ Summary' : (compress && n !== st.step ? String(disp) : disp + ' · ' + name);
      if (n === 2 && st.colour) {
        var nc = self.colourOf(st.colour);
        var nthumb = nc && (nc.thumb || nc.matte || nc.img);
        if (nthumb) label = '<span class="kb__navdot" style="background-image:url(' + nthumb + ')"></span>' + label;
      }
      return '<button type="button" class="' + cls + '" data-kb-go="' + n + '"' + (n > reach ? ' disabled' : '') + '>' + label + '</button>';
    }).join('');

    var tip = d.querySelector('.kb__tip');
    if (this.mode === 'fonzie') { tip.hidden = false; tip.querySelector('.kb__tip-text').textContent = TIPS[st.step]; }
    else tip.hidden = true;

    var body = d.querySelector('.kb__body');
    if (!(opts && opts.keepBody)) {
      body.innerHTML = this['step' + st.step]();
      body.scrollTop = 0;
    }
    if (st.step === 2 && st.colour && !(opts && opts.keepBody)) {
      // scroll on EVERY full render of this step: the post-variants re-render
      // rebuilds the body and resets scrollTop, so a one-shot scroll gets wiped.
      // The pulse animation still runs only once per open.
      var kb2 = this;
      var firstFlash = !this._flashed;
      this._flashed = true;
      requestAnimationFrame(function () {
        var onSw = kb2.dialog.querySelector('.kb__sw.on');
        if (!onSw) return;
        try { onSw.scrollIntoView({ block: 'center', behavior: 'instant' }); } catch (e) { onSw.scrollIntoView(); }
        if (firstFlash) {
          onSw.classList.add('kb__sw--flash');
          setTimeout(function () { onSw.classList.remove('kb__sw--flash'); }, 2600);
        }
      });
    }
    if (st.step === 3 || st.step === 4) this.priceDeltas(st.step);
    this.footer();
    if (st.step === 4) this.prewarmExpress();
    if (st.step === 5) {
      var kb5 = this;
      requestAnimationFrame(function () { kb5.fitSummaryMedia(); });
      // fonts, ratings and the wallet row all land late and grow the panel —
      // re-fit as they settle so the image absorbs the difference, not the layout
      [500, 1400, 3000, 4500].forEach(function (t) {
        setTimeout(function () { kb5.fitSummaryMedia(); }, t);
      });
      this.loadExpress();
    }
  };

  KB.prototype.head = function (q, sub) {
    return '<div class="kb__stephead"><h2>' + q + '</h2>' + (sub ? '<p>' + sub + '</p>' : '') + '</div>';
  };

  KB.prototype.galleryFor = function (h) { return (this.gallery || {})[h] || []; };

  KB.prototype.ratingFor = function (h) {
    var r = this.ratings[h];
    return (r && r.n) ? r : null;
  };
  KB.prototype.fetchRating = function (h) {
    var self = this, pid = this.pids[h];
    if (!pid || this.ratings[h]) return;
    this.ratings[h] = { pending: true };
    fetch('https://stamped.io/api/widget/reviews?productId=' + pid +
          '&apiKey=pubkey-m684YeqzQF725n4fW46WZyFGKD62wB&storeUrl=dipyourcar-com.myshopify.com&take=1')
      .then(function (r) { return r.json(); })
      .then(function (j) {
        self.ratings[h] = { r: +j.rating || 0, n: +j.total || 0 };
        if (self.state.colour === h && self.dialog && self.dialog.open) {
          self.render({ keepBody: self.state.step === 2 });
        }
      })
      .catch(function () { self.ratings[h] = { r: 0, n: 0 }; });
  };

  KB.prototype.stepCopy = function (n, key, dflt) {
    var sc = (this.copy.steps || {})[n] || {};
    return sc[key] == null ? dflt : sc[key];
  };

  KB.prototype.stdFinishLabel = function (c) {
    return 'Standard ' + (c && /^yes$/i.test(c.pearl) ? 'Satin' : 'Matte');
  };

  KB.prototype.step1 = function () {
    var st = this.state, self = this;
    // vehicle art: theme settings first (user-controlled), black render fallback
    var blackSlug = this.renderMap['matte-black-car-kit'] || this.renderMap['black-car-kit'];
    var SIZE_TOK = { compact: '-atv', sedan: '', suv: '-large', xl: '-xl' };
    var lockin = '';
    var pc = st.colour && this.colourOf(st.colour);
    if (pc) {
      var pthumb = pc.thumb || pc.matte || pc.img;
      lockin = '<div class="kb__lockin">' +
        (pthumb ? '<img src="' + pthumb + '" alt="">' : '') +
        '<span class="kb__lockin-txt"><b>' + esc(pc.title) + '</b> is locked in' +
        '<i>Pick your vehicle size to continue.</i></span>' +
        '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>' +
        '<button type="button" class="kb__lockin-change" data-kb-change>Change</button>' +
        '</div>';
    }
    return this.head(this.stepCopy(1, 'h', 'What are you spraying?'), this.stepCopy(1, 'sub', 'Choose the size of your vehicle.')) +
      lockin +
      '<div class="kb__grid kb__grid--2">' + VEHICLES.map(function (v) {
        var im = self.imgs[v.key] || ((blackSlug && self.rendersBase) ? (self.rendersBase + blackSlug + SIZE_TOK[v.key] + '-matte.webp') : null);
        return '<button type="button" class="kb__opt kb__opt--media' + (st.vehicle === v.key ? ' on' : '') + '" data-kb-pick="vehicle" data-kb-val="' + v.key + '">' +
          (im ? '<img src="' + im + '" loading="lazy" alt="">' : '<span class="kb__car kb__car--' + v.key + '"></span>') +
          '<b>' + v.label + '</b>' + (v.eg ? '<i>' + v.eg + '</i>' : '') + '</button>';
      }).join('') + '</div>';
  };

  KB.prototype.step2 = function () {
    var st = this.state, self = this;
    if (!this.catalog.length) return this.head(this.stepCopy(2, 'h', 'Pick your color'), '') + '<p class="kb__empty">Colors are unavailable right now — <a href="/collections/' + this.collection + '">browse the collection</a>.</p>';

    // row 1: colour families from the catalogue (dot swatches), row 2: finish types
    var fams = [];
    this.catalog.forEach(function (c) {
      if (!c.cf) return;
      var key = c.cf.toLowerCase();
      var f = fams.find(function (x) { return x.key === key; });
      var hx = (typeof c.chex === 'string' && /^(#|rgb|hsl)/.test(c.chex)) ? c.chex : '';
      if (f) { f.n++; if (!f.hex && hx) f.hex = hx; if (!f.img && c.cimg) f.img = c.cimg; }
      else fams.push({ key: key, label: c.cf, hex: hx || FAMILY_HEX[key] || '', img: c.cimg || '', n: 1 });
    });
    var list = this.catalog.filter(function (c) {
      return st.cfilter === 'all' || (c.cf && c.cf.toLowerCase() === st.cfilter.toLowerCase());
    });

    fams.sort(function (a, b) { return (a.label === 'Black' ? -1 : b.label === 'Black' ? 1 : b.n - a.n); });
    var famRow = '<div class="kb__filters kb__filters--dots">' +
      fams.map(function (f) {
        var on = st.cfilter === f.label;
        // theme parity: the swatch image from the colour metaobject wins (it's what the
        // collection filters show), then its hex, then the fallback map, then the gradient
        var dot = f.img
          ? '<span class="kb__dot" style="background-image:url(' + esc(f.img) + ');background-size:cover"></span>'
          : (f.hex ? '<span class="kb__dot" style="background:' + esc(f.hex) + '"></span>' : '<span class="kb__dot kb__dot--multi"></span>');
        return '<button type="button" class="' + (on ? 'on' : '') + '" data-kb-cfilter="' + (on ? 'all' : esc(f.label)) + '" title="' + esc(f.label) + '" aria-label="' + esc(f.label) + '" aria-pressed="' + on + '">' + dot + '</button>';
      }).join('') + '</div>';

    return this.head(this.stepCopy(2, 'h', 'Pick your color'), list.length + ' of ' + this.catalog.length + ' colors — tap to see it big.') +
      famRow +
      '<div class="kb__swatches">' + list.map(function (p) {
        var thumb = p.thumb || p.matte || p.img;
        return '<button type="button" class="kb__sw' + (st.colour === p.handle ? ' on' : '') + '" data-kb-pick="colour" data-kb-val="' + p.handle + '" title="' + esc(p.title) + '">' +
          (thumb ? '<img src="' + thumb + '" loading="lazy" alt="">' : '') + '<i>' + p.title + '</i></button>';
      }).join('') + '</div>';
  };

  // slim colour band (mobile): travels with the customer since the grid is skipped
  KB.prototype.slimLockin = function () {
    var c = this.state.colour && this.colourOf(this.state.colour);
    if (!(this.skipColor && c)) return '';
    var t = c.thumb || c.matte || c.img;
    return '<div class="kb__lockin kb__lockin--slim">' +
      (t ? '<img src="' + t + '" alt="">' : '') +
      '<span class="kb__lockin-txt"><b>' + esc(c.title) + '</b></span>' +
      '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="#17a673" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>' +
      '<button type="button" class="kb__lockin-change" data-kb-change>Change</button>' +
      '</div>';
  };
  KB.prototype.step3 = function () {
    var st = this.state, self = this;
    var desc = st.sprayer ? (this.copy.sprayer[st.sprayer] || '') : '';
    return this.slimLockin() + this.head(this.stepCopy(3, 'h', 'Add a Sprayer'), this.stepCopy(3, 'sub', '')) +
      '<div class="kb__rows-opts kb__rows-opts--n' + this.sprayerOpts().length + '">' + this.sprayerOpts().map(function (sp) {
        var im = self.imgs[sp.img];
        return '<button type="button" class="kb__rowopt' + (st.sprayer === sp.key ? ' on' : '') + '" data-kb-pick="sprayer" data-kb-val="' + sp.key + '">' +
          (im ? '<img src="' + im + '" loading="lazy" alt="">' : '<span></span>') +
          '<span class="kb__rowopt-txt"><b>' + sp.label + '</b><i>' + sp.sub + '</i></span>' +
          '<em data-kb-delta="sprayer:' + sp.key + '"></em></button>';
      }).join('') + '</div>' +
      (desc ? '<div class="kb__optdesc">' + desc + '</div>' : '');
  };

  KB.prototype.step4 = function () {
    var st = this.state, c = this.colourOf(st.colour);
    // Standard-finish copy differs by colour class: Pearl colours (pearl topcoat stage)
    // read as satin; PDS / Performance solids read as matte
    var descKey = st.finish === 'satin'
      ? 'satin_' + (c && /^yes$/i.test(c.pearl) ? 'pearl' : 'pds')
      : st.finish;
    var desc = st.finish ? (this.copy.finish[descKey] || this.copy.finish[st.finish] || '') : '';
    var shape = (st.finish && c) ? (st.finish === 'uhg' ? (c.gloss || c.matte) : (c.matte || c.gloss)) : null;
    var stdLbl = this.stdFinishLabel(c);
    return this.slimLockin() + this.head(this.stepCopy(4, 'h', 'Which finish?'), c ? c.title + ' — pick to preview it.' : '') +
      '<div class="kb__rows-opts kb__rows-opts--n2 kb__rows-opts--text">' + FINISHES.map(function (f) {
        return '<button type="button" class="kb__rowopt kb__rowopt--text' + (st.finish === f.key ? ' on' : '') + '" data-kb-pick="finish" data-kb-val="' + f.key + '">' +
          '<span class="kb__rowopt-txt"><b>' + (f.key === 'satin' ? stdLbl : f.label) + '</b></span>' +
          '<em data-kb-delta="finish:' + f.key + '"></em></button>';
      }).join('') + '</div>' +
      (st.finish ? '<div class="kb__optdesc kb__optdesc--finish">' +
        (shape ? '<img src="' + shape + '" alt="">' : '') +
        (desc ? '<div>' + desc + '</div>' : '') + '</div>' : '');
  };

  KB.prototype.step5 = function () {
    var st = this.state, self = this;
    var c = this.colourOf(st.colour);
    var v = this.matchedVariant();
    var veh = VEHICLES.find(function (x) { return x.key === st.vehicle; });
    var spr = SPRAYERS.find(function (x) { return x.key === st.sprayer; });
    var fin = FINISHES.find(function (x) { return x.key === st.finish; });
    var ai = this.renderSrc(c);
    var shape = c ? (st.finish === 'uhg' ? (c.gloss || c.matte) : (c.matte || c.gloss)) : null;
    var big = (st.view === 'render' && ai) ? ai : shape;   // shape leads; AI on demand
    var finLbl = fin ? (fin.key === 'satin' ? this.stdFinishLabel(c) : fin.label) : '';
    var isAI = big === ai && !!ai && st.view === 'render';

    function row(label, value, img, step) {
      return '<button type="button" class="kb__sumrow" data-kb-go="' + step + '">' +
        (img ? '<img src="' + img + '" loading="lazy" alt="">' : '<span class="kb__sumrow-ph"></span>') +
        '<span class="kb__sumrow-txt"><i>' + label + '</i><b>' + (value || '—') + '</b></span>' +
        '<span class="kb__sumrow-go" aria-hidden="true">›</span></button>';
    }

    return this.head(this.stepCopy(5, 'h', 'Your build'), this.stepCopy(5, 'sub', 'Tap any part of it to change it.')) +
      '<div class="kb__sum3">' +
        '<div class="kb__sum3-media' + (isAI ? '' : ' is-shape') + '">' + (big ? '<img src="' + big + '" alt="">' : '') +
          (function () {
            var acts = (ai ? '<button type="button" data-kb-view class="' + (isAI ? 'on' : '') + '" title="See it on a car" aria-label="Toggle car render">' + AI_ICON + '</button>' : '') +
              (self.galleryFor(st.colour).length ? '<button type="button" data-kb-gal title="Photo gallery" aria-label="Photo gallery">' + GAL_ICON + '</button>' : '');
            return acts ? '<div class="kb__sum3-act">' + acts + '</div>' : '';
          })() +
          (isAI ? '<button type="button" class="kb__ainote kb__ainote--media" data-kb-ainote>Render preview <u>ⓘ</u></button>' : '') +
        '</div>' +
        '<div class="kb__sum3-panel">' +
          '<b class="kb__sum3-name">' + (c ? c.title : 'Your color') + '</b>' +
          '<span class="kb__sum3-sub">' + (function () {
            var sr = self.ratingFor(st.colour);
            return (sr ? '<i class="kb__stars">★ ' + sr.r.toFixed(1) + ' (' + sr.n + ')</i> · ' : '');
          })() + finLbl + (veh ? ' · ' + veh.label : '') + '</span>' +
          '<span class="kb__sum3-price">' + this.priceHTML(v) +
            (this.essCount() ? '<i class="kb__ess-note">+ ' + this.essCount() + ' essentials · ' + money(this.essTotal()) + '</i>' : '') + '</span>' +
          '<div class="kb__sum3-rows">' +
            row('Vehicle', veh && veh.label, this.imgs[st.vehicle], 1) +
            row('Color', c && c.title, c && (c.matte || c.img), 2) +
            row('Sprayer', spr && spr.label, spr && this.imgs[spr.img], 3) +
            (this.preset === 'beginner'
              ? row('Finish', this.stdFinishLabel(c), shape, 3).replace('data-kb-go="3"', 'disabled style="pointer-events:none"')
              : row('Finish', finLbl, shape, 4)) +
            (this.essCatalog.length ? '<button type="button" class="kb__sumrow kb__sumrow--ess" data-kb-ess-open>' +
              '<img src="' + this.essCatalog[0].img + '" loading="lazy" alt="">' +
              '<span class="kb__sumrow-txt"><i>' + esc(this.essCopy('label', 'Project Essentials')) + '</i><b>' +
                (this.essCount() ? this.essCount() + ' added · ' + money(this.essTotal()) : esc(this.essCopy('teaser', 'Tape off, clean up, protect. Add extras'))) +
              '</b></span>' +
              '<span class="kb__sumrow-go" aria-hidden="true">›</span></button>' : '') +
          '</div>' +
        '</div>' +
      '</div>' +
      (v || this.kitOut(st.colour) ? '' : '<p class="kb__warn">That exact combination isn\'t available — tap a row to adjust.</p>') +
      (this.kitOut(st.colour)
        ? '<button type="button" class="kb__atc kb__atc--oos" data-kb-oos>Email me when it\'s back</button>'
        : '<div class="kb__ctazone">' +
          '<button type="button" class="kb__atc" data-kb-atc' + (v ? '' : ' disabled') + '>' + (this.entry === 'edit' ? 'Update Your Kit' : 'Add Kit to Cart') + '</button>' +
          '<div class="kb__express' + (v ? ' kb__express--loading' : '') + '" data-kb-express' + (v ? '' : ' hidden') + '></div>' +
          '<button type="button" class="kb__checkout" data-kb-checkout' + (v ? ' style="display:none"' : ' disabled') + '><svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/><path d="m9 12 2 2 4-4"/></svg> Checkout Now</button>' +
          '</div>');
  };

  // Express wallet ROW — same wallets as the checkout's express wall.
  // Fast path: the cart sync starts at STEP 4 (the build is fully known there),
  // the row section is prefetched as soon as the sync lands, and on narrow
  // screens the scale-down is applied AT INJECTION (slot width predicts the
  // stacking; no detect-then-fix round trip). Hydration is polled every 120ms
  // and the row reveals the moment it is ready — already at final size, so
  // nothing snaps. Fallback at every stage is the classic Checkout Now.
  KB.prototype.prewarmExpress = function () {
    var self = this, st = this.state;
    var v = this.matchedVariant();
    if (!v || this.kitOut(st.colour)) return;
    var sig = this.buildSig();
    if (this._xBusy) return;
    if (this._xSynced && this._xSig === sig) { if (!this._xRow) this.fetchRowSection(); return; }
    this._xBusy = true;
    var removeOld = Promise.resolve();
    (this._xKeys || []).forEach(function (k) {
      removeOld = removeOld.then(function () {
        return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: k, quantity: 0 }) }).catch(function () {});
      });
    });
    var bid = 'kb-' + v.id + '-' + Math.random().toString(36).slice(2, 8);
    removeOld
      .then(function () {
        return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(self.buildPayload(bid)) });
      })
      .then(function (r) { if (!r.ok) throw new Error('precart ' + r.status); return r.json(); })
      .then(function (j) {
        self._xKeys = (j.items || []).map(function (i) { return i.key; });
        self._xSynced = true; self._xSig = sig; self._xBid = bid; self._xBusy = false;
        self.track('builder_express_precart', { label: self.surface + '|' + st.colour + '|' + bid });
        self.fetchRowSection();
        if (self.state.step === 5) self.loadExpress();
      })
      .catch(function (err) {
        self._xBusy = false; self._xSyncFailed = true;
        self.track('builder_express_error', { label: String((err && err.message) || err).slice(0, 60) });
        if (self.state.step === 5) self.loadExpress();
      });
  };
  KB.prototype.fetchRowSection = function () {
    var self = this;
    if (this._xRow || this._xRowBusy) return;
    this._xRowBusy = true;
    fetch('/cart?section_id=kb-express-row')
      .then(function (r) { if (!r.ok) throw new Error('row HTTP ' + r.status); return r.text(); })
      .then(function (html) {
        self._xRow = html; self._xRowBusy = false;
        if (self.state.step === 5) self.loadExpress();
      })
      .catch(function () { self._xRowBusy = false; self._xRowFailed = true;
        if (self.state.step === 5) self.loadExpress(); });
  };
  KB.prototype.loadExpress = function () {
    var self = this, d = this.dialog, st = this.state;
    var slot = d.querySelector('[data-kb-express]');
    var cn = d.querySelector('[data-kb-checkout]');
    var fallback = function () {
      if (slot) { slot.hidden = true; slot.innerHTML = ''; slot.classList.remove('kb__express--loading');
                  slot.style.removeProperty('height'); slot.style.removeProperty('overflow'); }
      if (cn) cn.style.display = '';
      self.fitSummaryMedia();
    };
    if (!slot) return;
    var v = this.matchedVariant();
    if (!v || this.kitOut(st.colour)) { fallback(); return; }
    if (this._xSyncFailed || this._xRowFailed) { this._xSyncFailed = this._xRowFailed = false; fallback(); return; }
    var sig = this.buildSig();
    if (!(this._xSynced && this._xSig === sig)) { this.prewarmExpress(); return; }
    if (!this._xRow) { this.fetchRowSection(); return; }
    if (slot.__settledSig === sig && slot.innerHTML) return;
    slot.innerHTML = this._xRow;
    slot.hidden = false;
    if (cn) cn.style.display = 'none';
    var inner = slot.firstElementChild;
    if (!inner) { fallback(); return; }
    inner.style.setProperty('visibility', 'hidden', 'important');
    // predictive narrow-scale: decide from slot width BEFORE hydration, so the
    // component lays out once at a width it likes and the skeleton already has
    // the final height. No detect-and-reflow, nothing to snap.
    var avail = slot.clientWidth || slot.getBoundingClientRect().width || 378;
    var scaled = null;
    if (avail < 560) {
      var LOGICAL = 680, s = avail / LOGICAL;
      inner.style.setProperty('width', LOGICAL + 'px', 'important');
      inner.style.setProperty('transform', 'scale(' + s.toFixed(4) + ')', 'important');
      inner.style.setProperty('transform-origin', 'left top', 'important');
      slot.style.setProperty('height', Math.ceil(48 * s) + 'px', 'important');
      slot.style.setProperty('min-height', '0', 'important');
      slot.style.setProperty('overflow', 'visible', 'important');
      scaled = s;
    } else {
      slot.style.setProperty('height', '44px', 'important');
      slot.style.setProperty('overflow', 'hidden', 'important');
    }
    if (!slot.__wired) {
      slot.__wired = true;
      slot.addEventListener('click', function () {
        self.track('builder_express_click', { label: self.surface + '|' + self.state.colour + '|' + (self._xBid || '') });
      }, true);
    }
    var ac = slot.querySelector('shopify-accelerated-checkout-cart');
    if (!ac) { fallback(); return; }
    // pin one-row for engines that honor outer layout (desktop); harmless when scaled
    var applying = false;
    var pin = function () {
      if (applying) return;
      applying = true;
      ac.style.setProperty('display', 'grid', 'important');
      ac.style.setProperty('grid-auto-flow', 'column', 'important');
      ac.style.setProperty('grid-auto-columns', '1fr', 'important');
      ac.style.setProperty('grid-template-columns', 'none', 'important');
      ac.style.setProperty('gap', '8px', 'important');
      ac.style.setProperty('width', '100%', 'important');
      [].forEach.call(ac.children, function (k) {
        k.style.setProperty('width', '100%', 'important');
        k.style.setProperty('min-width', '0', 'important');
        k.style.setProperty('grid-row', '1', 'important');
      });
      requestAnimationFrame(function () { applying = false; });
    };
    pin();
    try {
      var mo = new MutationObserver(pin);
      mo.observe(ac, { attributes: true, childList: true, subtree: true, attributeFilter: ['style', 'class'] });
      setTimeout(function () { mo.disconnect(); }, 10000);
    } catch (e) {}
    // fast poll: reveal the instant hydration lands, already at final size
    var t0 = Date.now();
    var poll = function () {
      if (self.state.step !== 5 || self.buildSig() !== sig) return;
      var skel = slot.querySelector('.shopify-payment-button__skeleton');
      var ready = ac.offsetHeight >= 30 && !skel;
      if (ready) {
        slot.classList.remove('kb__express--loading');
        if (!scaled) { slot.style.removeProperty('height'); slot.style.removeProperty('overflow'); }
        inner.style.setProperty('visibility', 'visible', 'important');
        slot.__settledSig = sig;
        self.fitSummaryMedia();
        self.track('builder_express_shown', { label: self.surface + '|' + st.colour + '|' + self._xBid });
        setTimeout(function () {
          var kids = [].slice.call(ac.children);
          var tops = {};
          kids.forEach(function (k) { tops[Math.round(k.getBoundingClientRect().top)] = 1; });
          var sg = kids.map(function (k) { return k.tagName.toLowerCase().replace('shopify-', '').replace('-wallet', '').replace('-button', ''); }).join(',');
          self.track('builder_express_layout', { label: Object.keys(tops).length + 'r|' + kids.length + 'b|' + window.innerWidth + 'w|' + (scaled ? 'z' + scaled.toFixed(2) + '|' : '') + sg });
        }, 300);
        return;
      }
      if (Date.now() - t0 > 4500) { self.track('builder_express_error', { label: 'no-hydrate-row' }); fallback(); return; }
      setTimeout(poll, 120);
    };
    poll();
  };

  KB.prototype.priceDeltas = function (step) {
    var self = this, st = this.state;
    var kind = step === 3 ? 'sprayer' : 'finish';
    var opts = step === 3 ? this.sprayerOpts() : FINISHES;
    var saved = st[kind], prices = {};
    opts.forEach(function (o) { st[kind] = o.key; var v = self.matchedVariant(); prices[o.key] = v ? v.price : null; });
    st[kind] = saved;
    var valid = Object.values(prices).filter(function (x) { return x != null; });
    if (!valid.length) return;
    var base = Math.min.apply(null, valid);
    this.dialog.querySelectorAll('[data-kb-delta]').forEach(function (el) {
      var key = el.getAttribute('data-kb-delta').split(':')[1];
      if (prices[key] == null) { el.textContent = ''; return; }
      var delta = prices[key] - base;
      el.textContent = '+ ' + money(Math.max(0, delta));
      el.className = delta <= 0 ? 'inc' : '';
    });
  };

  // summary media fills the exact free space (mobile): measure, don't guess
  KB.prototype.fitSummaryMedia = function () {
    var d = this.dialog;
    if (!d || this.state.step !== 5 || window.innerWidth >= 900) return;
    var media = d.querySelector('.kb__sum3-media');
    var panel = d.querySelector('.kb__sum3-panel');
    var atc = d.querySelector('.kb__atc, .kb__atc--oos');
    if (!media || !panel || !atc) return;
    // the theme transitions this element's height (.18s): measuring right after a
    // set reads MID-ANIMATION values, which made repeated fits land on the floor.
    // Suspend the transition for the measure+set, restore it a frame later.
    media.style.setProperty('transition', 'none', 'important');
    media.style.height = '84px';
    void media.offsetHeight; /* flush layout before measuring */
    // the whole fixed CTA zone (ATC + wallet badges) is the boundary now
    var zone = d.querySelector('.kb__ctazone');
    var boundary = (zone || atc).getBoundingClientRect().top - 14;
    var free = boundary - panel.getBoundingClientRect().bottom;
    var h = Math.max(84, Math.min(380, 84 + free));
    media.style.height = h + 'px';
    void media.offsetHeight;
    requestAnimationFrame(function () { media.style.removeProperty('transition'); });
  };

  KB.prototype.footer = function () {
    var v = this.matchedVariant(), st = this.state, d = this.dialog;
    var c = this.colourOf(st.colour);
    d.querySelector('.kb__total-note').textContent = c ? c.title : 'Your kit';
    d.querySelector('.kb__total-amt').innerHTML = this.priceHTML(v, true);
    var next = d.querySelector('.kb__next');
    next.style.display = st.step === 5 ? 'none' : '';
    var need = { 1: 'vehicle', 2: 'colour', 3: 'sprayer', 4: 'finish' }[st.step];
    next.disabled = !!(need && !st[need]);
  };

  // one string per build: variant + essentials — decides when the cart re-syncs
  KB.prototype.buildSig = function () {
    var v = this.matchedVariant(), e = this.state.ess || {};
    return (v ? v.id : 0) + '~' + Object.keys(e).sort().map(function (k) { return k + ':' + e[k]; }).join(',');
  };
  KB.prototype.buildPayload = function (bid) {
    var st = this.state, v = this.matchedVariant();
    var props = { _build_id: bid, _build_source: this.surface + '-' + this.mode, _build_entry: this.entry };
    // the complete build, hash-encoded: makes every cart line a saved, editable
    // build (the cart's "Edit kit" link reopens the builder from this)
    try { props._build_state = btoa(JSON.stringify({ step: 5, vehicle: st.vehicle, colour: st.colour, sprayer: st.sprayer, finish: st.finish })); } catch (e) {}
    var lines = this.buildItems();
    if (lines) lines.forEach(function (l) { props['\u2022 ' + l] = '\u2713'; });
    var items = [{ id: v.id, quantity: this._editQty || 1, properties: props }];
    var essSel = st.ess || {};
    this.essCatalog.forEach(function (x) { if (essSel[x.id]) items.push({ id: x.id, quantity: essSel[x.id] }); });
    return { items: items };
  };

  KB.prototype.addToCart = function (direct) {
    var self = this, st = this.state, v = this.matchedVariant();
    if (!v) return;
    var btn = this.dialog.querySelector('[data-kb-atc]');
    var combo = this.surface + '|' + [st.vehicle, st.colour, st.sprayer, st.finish].join('|');
    var atcLabel = this.entry === 'edit' ? 'Update Your Kit' : 'Add Kit to Cart';
    // the background cart-sync may still be in flight: adding now would race it
    // and land TWO kit lines. Wait for it to settle, then re-enter.
    if (this._xBusy) {
      btn.disabled = true; btn.textContent = 'Updating\u2026';
      var t0 = Date.now();
      (function waitSync() {
        if (!self._xBusy) { btn.disabled = false; self.addToCart(direct); return; }
        if (Date.now() - t0 > 10000) { btn.disabled = false; btn.textContent = atcLabel; return; }
        setTimeout(waitSync, 250);
      })();
      return;
    }
    // the review-step express sync may already have put this exact build in the
    // cart — never add it twice
    if (this._xSynced && this._xSig === this.buildSig()) {
      this.track('builder_atc', { label: combo + '|' + this._xBid });
      this.track('builder_complete', { label: combo, skin: this.mode, direct: !!direct });
      if (direct) { this.track('builder_checkout_now', { label: combo }); window.location.href = '/checkout'; return; }
      this.close();
      var cd0 = document.querySelector('cart-drawer');
      if (cd0 && typeof cd0.show === 'function') {
        if (typeof cd0._refreshSections === 'function') cd0._refreshSections();
        cd0.show();
      } else { window.location.href = '/cart'; }
      return;
    }
    // ShipStation parity: the packing slip reads "• {qty} x {name}: ✓" lines,
    // same contract as ckb26's writeOrderProperties()
    var bid = 'kb-' + v.id + '-' + Math.random().toString(36).slice(2, 8);
    var payload = this.buildPayload(bid);
    this.track('builder_atc', { label: combo + '|' + bid });
    btn.disabled = true; btn.textContent = this.entry === 'edit' ? 'Updating\u2026' : 'Adding\u2026';
    var removeOld = Promise.resolve();
    (self._xKeys || []).forEach(function (k) {
      removeOld = removeOld.then(function () {
        return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: k, quantity: 0 }) }).catch(function () {});
      });
    });
    removeOld
      .then(function () {
        return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) });
      })
      .then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); })
      .then(function (j) {
        self._xKeys = ((j && j.items) || []).filter(function (it) { return it.properties && it.properties._build_id; }).map(function (it) { return it.key; });
        self._xSynced = true; self._xSig = self.buildSig();
        self.track('builder_complete', { label: combo, skin: self.mode, direct: !!direct });
        if (direct) { self.track('builder_checkout_now', { label: combo }); window.location.href = '/checkout'; return; }
        btn.disabled = false; btn.textContent = atcLabel;
        self.close();
        var cd = document.querySelector('cart-drawer');
        if (cd && typeof cd.show === 'function') {
          if (typeof cd._refreshSections === 'function') cd._refreshSections();
          cd.show();
        } else { window.location.href = '/cart'; }
      })
      .catch(function () { self.track('builder_atc_error', { label: combo }); btn.disabled = false; btn.textContent = atcLabel; alert('Could not add to cart — please try again.'); });
  };

  customElements.define('dyc-kit-builder', KB);
})();
